import {useContext, useEffect, useRef} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "./GlobalReducer";
import {mergeFavorite} from "./api/customer";
import {LOCAL_STORAGE_KEY_FAVORITE, LOCAL_STORAGE_KEY_FAVORITE_LAST_UPDATE} from "./Config";
import useInterval from "./utils/useInterval";
import {FavoriteItemInterface} from "./interfaces/core/FavoriteItemInterface";

export default function FavoriteServerSync() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const previousFavoriteUidRef = useRef<string | null>(null);
    const lastUpdateTimestamp = useRef<number | null>(null);

    const updateFavorite = (favorite: FavoriteItemInterface[], forceUpdate = false) => {
        if (state.customer?.id && state.customer?.sign && window.document.hasFocus() && favorite && favorite.length > 0) {
            mergeFavorite(state.customer.id, state.customer.sign, favorite, lastUpdateTimestamp.current || 0).then(favoriteResponse => {
                const currentFavoriteUid = favorite.map(item => item.model_id + '-' + item.color_special ).sort().join('|');
                const newFavoriteUid = favoriteResponse.favorite?.map(item => item.model_id + '-' + item.color_special).sort().join('|');

                if (currentFavoriteUid !== newFavoriteUid) {
                    dispatch({
                        type: ReducerActionType.SET_FAVORITE,
                        payload: favoriteResponse.favorite
                    });
                    previousFavoriteUidRef.current = currentFavoriteUid;
                    lastUpdateTimestamp.current = favoriteResponse.timestamp;
                }

            });
        }
    };

    useEffect(() => {
        if (state.favorites.length > 0) {
            lastUpdateTimestamp.current = Math.floor((new Date().getTime()) / 1000);
        }
    }, [state.favorites]);

    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY_FAVORITE_LAST_UPDATE, lastUpdateTimestamp.current?.toString() || '0');
    }, [lastUpdateTimestamp.current]);

    // Properly handle the window focus event
    useEffect(() => {
        lastUpdateTimestamp.current = parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_FAVORITE_LAST_UPDATE)|| '0') ;

        const handleFocus = () => {

            // dispatch({
            //     type: ReducerActionType.SET_FAVORITE,
            //     payload: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_FAVORITE) || '[]')
            // });
        };

        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    useInterval(() => {
        updateFavorite(state.favorites,true);
    }, 11000);

    return (<></>);
}